import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box, InputAdornment } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDeadline } from "../../../contexts/DeadlineContext";


const Payment = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();

    const [settings, setPyamentSettings] = useState({
        PAYTAB_COUNTRY: '',
        PAYTAB_MERCHANT_EMAIL: '',
        PAYTAB_SECRET_KEY: '',
        PAYTAB_MERCHANT_ID: '',
        PAYTAB_STATUS: '',
        PAYTAB_MODE: '',
        PAYTAB_CURRENCY: "",
        PAYTAB_TAX: "",
        BANK_STATUS: "",
        CASH_STATUS: "",
        FREE_STATUS: "",
    });

    useEffect(() => {

        axios.get(`/api/get-setting/${eventid}`)
            .then(response => {
                const settingsData = response.data.settings;
                setPyamentSettings(settingsData);
            })
            .catch(error => {
                console.error('Error fetching email settings:', error);
            });
    }, []);



    const handleChange = (event) => {
        const { name, value } = event.target;
        setPyamentSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    };


    const StorePyamentSetting = (e) => {
        e.preventDefault();
        const eventid = localStorage.getItem('eventid');
        const test = 123;
        const data = {
            eventid,
            settings,
        };

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/configuration-setting`, data,).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');

                    history.push('/admin/payment/setting');
                }
                // else {
                //     setAddSmtpSetting({ ...addSmtpSetting, error_list: res.data.validate_error })
                // }
            });
        });


    }




    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 style={{ display: 'flex', justifyContent: 'flex-end', gap: '1%' }}>
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/paytab')}
                    >
                        Purplecube AED Payment Settings
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/paytab-two')}
                    >
                        Purplecube USD Payment Settings
                    </Button>

                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            PayTab Payment settings
                        </Typography>
                        <Box component="form" onSubmit={StorePyamentSetting} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="Country-label">Country</InputLabel>
                                        <Select
                                            labelId="Country-label"
                                            id="Country"
                                            label="Country"
                                            name="PAYTAB_COUNTRY"
                                            value={settings.PAYTAB_COUNTRY || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={"SAU"}>Saudi Arabia</MenuItem>
                                            <MenuItem value={"UAE"}>United Arab Emirates </MenuItem>
                                            <MenuItem value={"USA"}>United States</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                {/* <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Country"
                                        autoFocus
                                        placeholder="Country"
                                        name='PAYTAB_COUNTRY'
                                        value={settings.PAYTAB_COUNTRY || ""}
                                        onChange={handleChange} />
                                </Grid> */}
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Merchant Emai"

                                        autoFocus
                                        name='PAYTAB_MERCHANT_EMAIL'
                                        value={settings.PAYTAB_MERCHANT_EMAIL || ""}
                                        onChange={handleChange} />
                                </Grid>



                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="Secret Key"

                                        autoComplete="new-password"
                                        name='PAYTAB_SECRET_KEY'
                                        value={settings.PAYTAB_SECRET_KEY || ""}
                                        onChange={handleChange} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Merchant ID"
                                        autoFocus
                                        name='PAYTAB_MERCHANT_ID'
                                        value={settings.PAYTAB_MERCHANT_ID || ""}
                                        onChange={handleChange} />
                                </Grid>



                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="currency-label">Currencies</InputLabel>
                                        <Select
                                            labelId="Currencies-label"
                                            id="Currencies"
                                            label="Currencies"
                                            name="PAYTAB_CURRENCY"
                                            value={settings.PAYTAB_CURRENCY || ""}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={"SAR"}>Saudi Riyal</MenuItem>
                                            <MenuItem value={"AED"}>United Arab Emirates Dirham</MenuItem>
                                            <MenuItem value={"USD"}>United States Dollar</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Tax Rate"
                                        autoFocus
                                        name='PAYTAB_TAX'
                                        value={settings.PAYTAB_TAX || ""}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Mode</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Mode"
                                            name="PAYTAB_MODE" // Ensure this matches the property name in your state
                                            value={settings.PAYTAB_MODE | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Online</MenuItem>
                                            <MenuItem value={0}>Offline</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Online Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Online Status "
                                            name="PAYTAB_STATUS" // Ensure this matches the property name in your state
                                            value={settings.PAYTAB_STATUS | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>


                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Bank Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Bank Status "
                                            name="BANK_STATUS" // Ensure this matches the property name in your state
                                            value={settings.BANK_STATUS | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Cash Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Cash Status "
                                            name="CASH_STATUS" // Ensure this matches the property name in your state
                                            value={settings.CASH_STATUS | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Free Status</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Free Status "
                                            name="FREE_STATUS" // Ensure this matches the property name in your state
                                            value={settings.FREE_STATUS | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>



                            </Grid>
                            <Grid container justifyContent="flex-end">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card >
            </Box >
        </div >
    );
}

export default Payment;
